
import ScopeOfWork from "../../ScopeOfWork";


export default function ServicesPage() {
  return (
    <>
    
      <ScopeOfWork mobileCarousel={false} />
    </>
  );
}